// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================
   MAIN WRAPPER
========================= */

.login-wrapper {
  display: flex;
  width: 100%;
  min-height: 100vh;
  background: #ffffff;
  overflow-x: hidden;
}


/* =========================
   LEFT IMAGE PANEL
========================= */

.login-left {
  width: 50%;
  min-height: 100vh;

  display: flex;
  align-items: center;
  justify-content: center;

  overflow: hidden;
}

.login-left img {
  width: 100%;
  height: auto;
  max-height: 100vh;
  object-fit: contain;
  display: block;
}


/* =========================
   RIGHT LOGIN PANEL
========================= */

.login-right {
  width: 50%;
  min-height: 100vh;

  background: #ffffff;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding: 40px 30px;
  box-sizing: border-box;
}


/* =========================
   LOGO
========================= */

.logo {
  width: min(280px, 80%);
  height: auto;
  margin-bottom: 35px;
}


/* =========================
   FORM
========================= */

.login-form {
  width: 100%;
  max-width: 420px;
}

.login-form h1 {
  font-size: 30px;
  margin: 0 0 30px;
  color: var(--primary-blue);
  text-align: center;
}


/* =========================
   FORM GROUP
========================= */

.form-group {
  width: 100%;
  margin-bottom: 22px;
}

.form-group label {
  display: block;

  font-size: 17px;
  font-weight: 600;

  margin-bottom: 8px;

  color: #000;
}


/* =========================
   INPUT
========================= */

.input-box {
  position: relative;
  width: 100%;

  display: flex;
  align-items: center;
}

.input-box input {
  width: 100%;
  height: 54px;

  box-sizing: border-box;

  padding: 0 50px;

  border-radius: 30px;
  border: none;

  background: #fdecec;

  font-size: 15px;
  outline: none;
}

.input-box input:focus {
  outline: 2px solid rgba(239, 47, 47, 0.15);
}


/* =========================
   INPUT ICON
========================= */

.input-box .icon {
  position: absolute;

  left: 20px;
  top: 50%;

  transform: translateY(-50%);

  font-size: 16px;
  opacity: 0.6;

  z-index: 2;
}


/* =========================
   PASSWORD TOGGLE
========================= */

.toggle-password {
  position: absolute;

  right: 18px;
  top: 50%;

  transform: translateY(-50%);

  font-size: 16px;

  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;

  z-index: 2;
}


/* =========================
   LOGIN BUTTON
========================= */

.login-form button[type="submit"] {
  width: 100%;
  height: 54px;

  margin-top: 8px;

  background: #ef2f2f;
  color: #ffffff;

  border: none;
  border-radius: 30px;

  font-size: 17px;
  font-weight: 600;

  cursor: pointer;

  transition: 0.2s ease;
}

.login-form button[type="submit"]:hover {
  background: #d92525;
}


/* =========================
   SIGNUP TEXT
========================= */

.login-form p {
  font-size: 14px;
  line-height: 1.5;
}


/* =========================
   TABLET
========================= */

@media (max-width: 900px) {

  .login-wrapper {
    min-height: 100vh;
  }

  .login-left {
    width: 42%;
  }

  .login-right {
    width: 58%;
    padding: 35px 25px;
  }

  .logo {
    width: 220px;
    margin-bottom: 30px;
  }

  .login-form {
    max-width: 380px;
  }
}


/* =========================
   MOBILE
========================= */

@media (max-width: 650px) {

  .login-wrapper {
    display: block;

    width: 100%;
    min-height: 100vh;

    overflow-x: hidden;
    overflow-y: auto;
  }


  /* Hide desktop illustration */
  .login-left {
    display: none;
  }


  /* Full width login */
  .login-right {
    width: 100%;
    min-height: 100vh;

    display: flex;
    align-items: center;
    justify-content: center;

    padding: 35px 20px;

    box-sizing: border-box;
  }


  .login-form {
    width: 100%;
    max-width: 420px;
  }


  .logo {
    width: min(230px, 75vw);
    margin-bottom: 30px;
  }


  .login-form h1 {
    font-size: 27px;
    margin-bottom: 25px;
  }


  .form-group {
    margin-bottom: 20px;
  }


  .form-group label {
    font-size: 16px;
  }


  .input-box input {
    height: 52px;
    font-size: 15px;
  }


  .login-form button[type="submit"] {
    height: 52px;
  }
}


/* =========================
   SMALL MOBILE
========================= */

@media (max-width: 400px) {

  .login-right {
    padding: 25px 16px;
  }

  .logo {
    width: 200px;
    margin-bottom: 25px;
  }

  .login-form h1 {
    font-size: 24px;
  }

  .form-group label {
    font-size: 15px;
  }

  .input-box input {
    height: 50px;
  }

  .login-form button[type="submit"] {
    height: 50px;
  }

  .login-form p {
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/LoginPage.css"],"names":[],"mappings":"AAEA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;;AAGA;;2BAE2B;;AAE3B;EACE,UAAU;EACV,iBAAiB;;EAEjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;;AAGA;;2BAE2B;;AAE3B;EACE,UAAU;EACV,iBAAiB;;EAEjB,mBAAmB;;EAEnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;;EAEvB,kBAAkB;EAClB,sBAAsB;AACxB;;;AAGA;;2BAE2B;;AAE3B;EACE,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;;AAGA;;2BAE2B;;AAE3B;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;;AAGA;;2BAE2B;;AAE3B;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;;EAEd,eAAe;EACf,gBAAgB;;EAEhB,kBAAkB;;EAElB,WAAW;AACb;;;AAGA;;2BAE2B;;AAE3B;EACE,kBAAkB;EAClB,WAAW;;EAEX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,sBAAsB;;EAEtB,eAAe;;EAEf,mBAAmB;EACnB,YAAY;;EAEZ,mBAAmB;;EAEnB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,0CAA0C;AAC5C;;;AAGA;;2BAE2B;;AAE3B;EACE,kBAAkB;;EAElB,UAAU;EACV,QAAQ;;EAER,2BAA2B;;EAE3B,eAAe;EACf,YAAY;;EAEZ,UAAU;AACZ;;;AAGA;;2BAE2B;;AAE3B;EACE,kBAAkB;;EAElB,WAAW;EACX,QAAQ;;EAER,2BAA2B;;EAE3B,eAAe;;EAEf,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;;EAEjB,UAAU;AACZ;;;AAGA;;2BAE2B;;AAE3B;EACE,WAAW;EACX,YAAY;;EAEZ,eAAe;;EAEf,mBAAmB;EACnB,cAAc;;EAEd,YAAY;EACZ,mBAAmB;;EAEnB,eAAe;EACf,gBAAgB;;EAEhB,eAAe;;EAEf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;;2BAE2B;;AAE3B;EACE,eAAe;EACf,gBAAgB;AAClB;;;AAGA;;2BAE2B;;AAE3B;;EAEE;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;AACF;;;AAGA;;2BAE2B;;AAE3B;;EAEE;IACE,cAAc;;IAEd,WAAW;IACX,iBAAiB;;IAEjB,kBAAkB;IAClB,gBAAgB;EAClB;;;EAGA,8BAA8B;EAC9B;IACE,aAAa;EACf;;;EAGA,qBAAqB;EACrB;IACE,WAAW;IACX,iBAAiB;;IAEjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,kBAAkB;;IAElB,sBAAsB;EACxB;;;EAGA;IACE,WAAW;IACX,gBAAgB;EAClB;;;EAGA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;;EAGA;IACE,eAAe;IACf,mBAAmB;EACrB;;;EAGA;IACE,mBAAmB;EACrB;;;EAGA;IACE,eAAe;EACjB;;;EAGA;IACE,YAAY;IACZ,eAAe;EACjB;;;EAGA;IACE,YAAY;EACd;AACF;;;AAGA;;2BAE2B;;AAE3B;;EAEE;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["@import \"./colors.css\";\r\n\r\n/* =========================\r\n   MAIN WRAPPER\r\n========================= */\r\n\r\n.login-wrapper {\r\n  display: flex;\r\n  width: 100%;\r\n  min-height: 100vh;\r\n  background: #ffffff;\r\n  overflow-x: hidden;\r\n}\r\n\r\n\r\n/* =========================\r\n   LEFT IMAGE PANEL\r\n========================= */\r\n\r\n.login-left {\r\n  width: 50%;\r\n  min-height: 100vh;\r\n\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n\r\n  overflow: hidden;\r\n}\r\n\r\n.login-left img {\r\n  width: 100%;\r\n  height: auto;\r\n  max-height: 100vh;\r\n  object-fit: contain;\r\n  display: block;\r\n}\r\n\r\n\r\n/* =========================\r\n   RIGHT LOGIN PANEL\r\n========================= */\r\n\r\n.login-right {\r\n  width: 50%;\r\n  min-height: 100vh;\r\n\r\n  background: #ffffff;\r\n\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n\r\n  padding: 40px 30px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n\r\n/* =========================\r\n   LOGO\r\n========================= */\r\n\r\n.logo {\r\n  width: min(280px, 80%);\r\n  height: auto;\r\n  margin-bottom: 35px;\r\n}\r\n\r\n\r\n/* =========================\r\n   FORM\r\n========================= */\r\n\r\n.login-form {\r\n  width: 100%;\r\n  max-width: 420px;\r\n}\r\n\r\n.login-form h1 {\r\n  font-size: 30px;\r\n  margin: 0 0 30px;\r\n  color: var(--primary-blue);\r\n  text-align: center;\r\n}\r\n\r\n\r\n/* =========================\r\n   FORM GROUP\r\n========================= */\r\n\r\n.form-group {\r\n  width: 100%;\r\n  margin-bottom: 22px;\r\n}\r\n\r\n.form-group label {\r\n  display: block;\r\n\r\n  font-size: 17px;\r\n  font-weight: 600;\r\n\r\n  margin-bottom: 8px;\r\n\r\n  color: #000;\r\n}\r\n\r\n\r\n/* =========================\r\n   INPUT\r\n========================= */\r\n\r\n.input-box {\r\n  position: relative;\r\n  width: 100%;\r\n\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.input-box input {\r\n  width: 100%;\r\n  height: 54px;\r\n\r\n  box-sizing: border-box;\r\n\r\n  padding: 0 50px;\r\n\r\n  border-radius: 30px;\r\n  border: none;\r\n\r\n  background: #fdecec;\r\n\r\n  font-size: 15px;\r\n  outline: none;\r\n}\r\n\r\n.input-box input:focus {\r\n  outline: 2px solid rgba(239, 47, 47, 0.15);\r\n}\r\n\r\n\r\n/* =========================\r\n   INPUT ICON\r\n========================= */\r\n\r\n.input-box .icon {\r\n  position: absolute;\r\n\r\n  left: 20px;\r\n  top: 50%;\r\n\r\n  transform: translateY(-50%);\r\n\r\n  font-size: 16px;\r\n  opacity: 0.6;\r\n\r\n  z-index: 2;\r\n}\r\n\r\n\r\n/* =========================\r\n   PASSWORD TOGGLE\r\n========================= */\r\n\r\n.toggle-password {\r\n  position: absolute;\r\n\r\n  right: 18px;\r\n  top: 50%;\r\n\r\n  transform: translateY(-50%);\r\n\r\n  font-size: 16px;\r\n\r\n  cursor: pointer;\r\n  user-select: none;\r\n\r\n  z-index: 2;\r\n}\r\n\r\n\r\n/* =========================\r\n   LOGIN BUTTON\r\n========================= */\r\n\r\n.login-form button[type=\"submit\"] {\r\n  width: 100%;\r\n  height: 54px;\r\n\r\n  margin-top: 8px;\r\n\r\n  background: #ef2f2f;\r\n  color: #ffffff;\r\n\r\n  border: none;\r\n  border-radius: 30px;\r\n\r\n  font-size: 17px;\r\n  font-weight: 600;\r\n\r\n  cursor: pointer;\r\n\r\n  transition: 0.2s ease;\r\n}\r\n\r\n.login-form button[type=\"submit\"]:hover {\r\n  background: #d92525;\r\n}\r\n\r\n\r\n/* =========================\r\n   SIGNUP TEXT\r\n========================= */\r\n\r\n.login-form p {\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n}\r\n\r\n\r\n/* =========================\r\n   TABLET\r\n========================= */\r\n\r\n@media (max-width: 900px) {\r\n\r\n  .login-wrapper {\r\n    min-height: 100vh;\r\n  }\r\n\r\n  .login-left {\r\n    width: 42%;\r\n  }\r\n\r\n  .login-right {\r\n    width: 58%;\r\n    padding: 35px 25px;\r\n  }\r\n\r\n  .logo {\r\n    width: 220px;\r\n    margin-bottom: 30px;\r\n  }\r\n\r\n  .login-form {\r\n    max-width: 380px;\r\n  }\r\n}\r\n\r\n\r\n/* =========================\r\n   MOBILE\r\n========================= */\r\n\r\n@media (max-width: 650px) {\r\n\r\n  .login-wrapper {\r\n    display: block;\r\n\r\n    width: 100%;\r\n    min-height: 100vh;\r\n\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n  }\r\n\r\n\r\n  /* Hide desktop illustration */\r\n  .login-left {\r\n    display: none;\r\n  }\r\n\r\n\r\n  /* Full width login */\r\n  .login-right {\r\n    width: 100%;\r\n    min-height: 100vh;\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n    padding: 35px 20px;\r\n\r\n    box-sizing: border-box;\r\n  }\r\n\r\n\r\n  .login-form {\r\n    width: 100%;\r\n    max-width: 420px;\r\n  }\r\n\r\n\r\n  .logo {\r\n    width: min(230px, 75vw);\r\n    margin-bottom: 30px;\r\n  }\r\n\r\n\r\n  .login-form h1 {\r\n    font-size: 27px;\r\n    margin-bottom: 25px;\r\n  }\r\n\r\n\r\n  .form-group {\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n\r\n  .form-group label {\r\n    font-size: 16px;\r\n  }\r\n\r\n\r\n  .input-box input {\r\n    height: 52px;\r\n    font-size: 15px;\r\n  }\r\n\r\n\r\n  .login-form button[type=\"submit\"] {\r\n    height: 52px;\r\n  }\r\n}\r\n\r\n\r\n/* =========================\r\n   SMALL MOBILE\r\n========================= */\r\n\r\n@media (max-width: 400px) {\r\n\r\n  .login-right {\r\n    padding: 25px 16px;\r\n  }\r\n\r\n  .logo {\r\n    width: 200px;\r\n    margin-bottom: 25px;\r\n  }\r\n\r\n  .login-form h1 {\r\n    font-size: 24px;\r\n  }\r\n\r\n  .form-group label {\r\n    font-size: 15px;\r\n  }\r\n\r\n  .input-box input {\r\n    height: 50px;\r\n  }\r\n\r\n  .login-form button[type=\"submit\"] {\r\n    height: 50px;\r\n  }\r\n\r\n  .login-form p {\r\n    font-size: 13px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
